<template>
    <tab-component class="min-100" :content="trainingsPages"></tab-component>

</template>

<script>
    import {mapActions, mapGetters} from 'vuex';
    import TabComponent from "../content/club/trainingsPage/TabComponent";
    import {Resize, Scroll} from 'vuetify/es5/directives'

    export default {
        name: "Training",
        directives: {
            Resize, Scroll
        },
        components: {TabComponent},
        computed: {
            ...mapGetters(['trainingsPages']),
        },
        methods: {
            ...mapActions(['getTrainingPages'])
        },
        created() {
            this.getTrainingPages()
            setTimeout(() => {
                this.$vuetify.goTo(0, {offset: 0, duration: 300, easing: 'easeOutCubic'})
            }, 100)
        }
    }
</script>

<style>
    .min-100 {
        min-height: 100vh;
    }
</style>
